$(function() {
    'use strict';

    $('.polling-container').each(function(i, pollingBlock) {
        var pollingId = $(pollingBlock).data('pollingId');
        var visiblePart = pollingId && readCookie(pollingId) ? '.polling-container__results' : '.polling-container__vote';
        $(pollingBlock).find(visiblePart).show();
    });

    $('.polling-form').submit(function(e) {
        e.preventDefault();
        var $form = $(this),
            url = $form.attr('action');
        var data = {};
        var voted = false;
        $(this).find('input').each(function(i, el) {
            var name = $(el).attr('name');
            if (name && ($(el).attr('type') == 'hidden' || $(el).is(':checked'))) {
                data[name] = $(el).val();
                if ($(el).is(':checked')) {
                    voted = true;
                }
            }
        });
        $.post(url, data);
        if (voted) {
            $(this).parents('.polling-container')
                .find('.polling-container__results')
                .show();
            $(this).hide();
        }
    });
});